<template>
  <form ref="form" class="kay-data-table">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{ $t("title.Foodpanda Menu Management") }}
            </h4>
          </div>
          <div class="card-body">
            <!-- Shop ID -->
            <div class="row margin-bottom-20">
              <div class="col-md-4 label-custom">
                <label for="shop-id">Shop ID</label>
              </div>
              <div class="col-md-6">
                <el-input
                  id="shop-id"
                  v-model="shopId"
                  placeholder="Shop ID"
                  width="180px"
                >
                </el-input>
              </div>
            </div>

            <!-- Foodpanda ID -->
            <div class="row margin-bottom-20">
              <div class="col-md-4 label-custom">
                <label for="foodpanda-id">Foodpanda ID</label>
              </div>
              <div class="col-md-6">
                <el-input
                  id="foodpanda-id"
                  v-model="foodpandaId"
                  placeholder="Foodpanda ID"
                  width="180px"
                >
                </el-input>
              </div>
            </div>

            <!-- Foodpanda Menu JSON -->
            <div class="row margin-bottom-20">
              <div class="col-md-4 label-custom">
                <label for="foodpanda-json">
                  {{ $t("Sidebar.GAA.Message.Foodpanda_Menu_JSON") }}</label
                >
              </div>
              <div class="col-md-8 margin-bottom-20">
                <input
                  type="file"
                  id="foodpanda-json"
                  @change="handleFileUpload"
                  accept=".json"
                  style="display: none"
                />
                <label
                  for="foodpanda-json"
                  class="btn btn-simple btn-block file-upload-label"
                >
                  <font-awesome-icon
                    :icon="['fas', 'upload']"
                    size="2x"
                    class="fa-upload"
                /></label>
                <br />
                <span v-if="fileName" class="file-name">{{ fileName }}</span>
              </div>

              <button
                class="btn btn-primary ml-3 mb-4 button-custom"
                @click.prevent="submitData"
              >
                {{ $t("Sidebar.GAA.Message.Upload") }}
              </button>

              <div class="col-md-12" v-if="jsonPreview">
                <vue-json-pretty
                  :show-line-number="true"
                  :showIcon="true"
                  :data="jsonPreview"
                ></vue-json-pretty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import swal from "sweetalert2";
import VueJsonPretty from "vue-json-pretty";
import { postFoodpandaMenu } from "src/javascripts/gaa/postData.js";
import "vue-json-pretty/lib/styles.css";

export default {
  components: {
    VueJsonPretty,
  },
  data() {
    return {
      shopId: "",
      foodpandaId: "",
      file: null,
      fileName: "",
      jsonPreview: "",
    };
  },
  mounted() {},
  watch: {},
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.file = file;
      this.fileName = file.name || "";
      const reader = new FileReader();
      reader.onload = (e) => {
        this.jsonPreview = JSON.parse(e.target.result);
      };
      reader.readAsText(file);
    },
    async submitData() {
      if (this.shopId && this.foodpandaId && this.jsonPreview) {
        try {
          await postFoodpandaMenu(
            this.shopId,
            this.foodpandaId,
            JSON.stringify(this.jsonPreview)
          );
          await swal.fire(this.$t("Sidebar.GAA.Message.Upload_Successful"));
          this.shopId = "";
          this.foodpandaId = "";
          this.file = null;
          this.jsonPreview = "";
          this.$refs.form.reset();
        } catch (error) {
          console.error("postFoodpandaMenu", error);
          swal.fire(
            error.data.error ||
              error.message ||
              this.$t("Sidebar.GAA.Message.Upload_Failed")
          );
        }
      } else {
        swal.fire(
          this.$t(
            "Sidebar.GAA.Message.Foodpanda_ID_and_Foodpanda_JSON_cannot_be_empty"
          )
        );
      }
    },
  },
};
</script>
<style scoped>
.kay-data-table {
  padding: 30px;
  height: calc(100vh - 70px);
}

.label-custom > label,
.button-custom {
  font-size: 14px;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.btn-block {
  padding: 10px 24px;
  font-size: 16px;
  cursor: pointer;
}

.file-upload-label {
  display: inline-block;
  width: 120px;
  height: 120px;
  line-height: 100px;
  text-align: center;
  border: 2px dashed #ccc;
  border-radius: 10px;
  transition: all 450ms;
  background-color: #f2f2f2;
}

.file-upload-label:hover {
  border-color: #fa7a50;
  background-color: #f9f9f9;
  opacity: 0.85;
}

.file-upload-label:hover .fa-upload {
  color: #fa7a50;
  opacity: 0.75;
  transition: color 450ms ease;
}

@media (max-width: 600px) {
  .kay-data-table {
    padding: 15px;
  }
}
</style>
